/* eslint-disable max-len */
import React, { useRef, useState, useEffect } from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
// import { useOnClickOutside } from "../../CommonMethods/OutsideClick";
export default function SubdivisionDropdownWithSearch({
    label,
    id,
    placeholder,
    value,
    disabled,
    emptyField,
    subdivisionData,
    selectedOrganizationName,
    handleSubdivisionListSearch,
    subdivisionFetching,
    selectedSubdivisionName,
    setSelectedSubdivisionName,
    setisOpensub,
    isOpensub,
    subdivisionloadingstatus,
    handleSelectionSubdivision,
    loading,
    isMonitor,
    addObserver,
    isFirstTimeFeching,
    setIsFirstTimeFetching,
    isSubDelete,
    setIsSubDelete
}) {
    const ref = useRef();
    const [displayEmptyMsg, setDisplayEmptyMsg] = useState('');
    const [isOpenSubDiv, setIsOpenSubDiv] = useState(false);
    const [searchValue, setSearchValue] = useState(""); 
    const buttonRef = useRef(null);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (subdivisionData !== undefined) {
            if (subdivisionData?.data?.length === 0) {
                setDisplayEmptyMsg('No results found.');
                return;
            }
            setDisplayEmptyMsg('');
        }

        if (isFirstTimeFeching && subdivisionData && !isSubDelete && subdivisionData.data&&searchValue?.trim()==='') {
            setIsFirstTimeFetching(false)
            setSelectedSubdivisionName(subdivisionData.data);
            setIsSubDelete(false)
        }
    }, [subdivisionData]);

    useEffect(() => {
        if (subdivisionData?.data?.length === 0) {
            setDisplayEmptyMsg('No results found');
        } else {
            setDisplayEmptyMsg('');
        }
        
        if (isOpensub) {
            setSearchValue("")
            value !== "" && handleSubdivisionListSearch("", 'apiCallavoid');
        }
    }, [isOpenSubDiv]);

    // Initialize selectedItems with all subdivisions on mount

    const handleSubDivClick = () => {
        setisOpensub(!isOpensub);
        // setIsOpenSubDiv(!isOpenSubDiv);
        if (isOpenSubDiv) {
            setSearchValue(""); // Clear search value when dropdown is closed
        }
    };

    useEffect(() => {
        handleSubdivisionListSearch('')
        setSearchValue('')
        return () => {
        };
    }, [isOpensub]);

    const handleSelectAll = (e,subdata) => {
        if(e.target.checked===true){
            const existingIds = new Set(selectedSubdivisionName?.length>0?selectedSubdivisionName?.map(item => item?.subdivision_id):[]);
            const newItems = subdata?.data?.filter(item => !existingIds.has(item?.subdivision_id));
            setSelectedSubdivisionName(prev => [...prev, ...newItems]);
        }
        else{
            const currentIds = subdata?.data?.map(item=>item?.subdivision_id)
            const filteredSubdiv = selectedSubdivisionName?.filter(item=>!(currentIds?.includes(item.subdivision_id)))
            setSelectedSubdivisionName(filteredSubdiv)
        }
    };

    const handleClearAll = () => {
        setSelectedSubdivisionName([]);
    };

    return (
        <div className='relative' ref={ref}>
            <label htmlFor='countryCode' className='text-xs font-semibold text-[#000] pb-1.5'>{label}</label>
            <button
                ref={buttonRef}
                onClick={handleSubDivClick}
                className={`border ${emptyField ? 'border-[#C81720]' : 'border-[#C5C9DA] '} ${addObserver !== undefined ? 'disabled:bg-[#E7EAF4]' : "disabled:opacity-50"} rounded-lg px-3.5 py-[11px] text-base font-normal 
                             text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center`}
                disabled={disabled}
                id={'subdivision_button'}
            >
                <p id={id} className={`${(selectedSubdivisionName.length === 0) ? 'text-[#52555D] ' : 'text-[#000B17] '}text-start text-sm more-lines`}>
                    {selectedSubdivisionName.length > 0 ? `${selectedSubdivisionName.length} selected` : placeholder}
                </p>
                <img loading='lazy' decoding='async' src="/images/dropdown_green.svg" alt="icon" className={`${isOpensub ? "transform rotate-180" : ""}`} />
            </button>
            <ul className={`py-4 pr-1 pl-4 rounded-lg bg-white z-[9] absolute top-[72px] w-full left-0 border border-[#C5C9DA] ${isOpensub ? "" : "hidden"}`} ref={dropdownRef}>
                <li>
                    <ul>
                        <li>
                            <div className="relative pr-3">
                                <label htmlFor=""></label>
                                <input
                                    type="text"
                                    autoComplete={"off"}
                                    id={isMonitor !== undefined ? 'search-value-subdivision' : "search-value"}
                                    placeholder={addObserver !== undefined ? 'Search by ID/name' : 'Search by ID/name'}
                                    className="border border-[#C5C9DA] rounded-[16px] pl-9 px-3 py-1.5 w-full outline-none"
                                    onChange={(e) => {
                                        setSearchValue(e.target.value); // Update search value state
                                        handleSubdivisionListSearch(e.target.value);
                                    }}
                                    value={searchValue}  />
                                <img src="/images/search_gray.svg" alt="icon" className="absolute top-[50%] -translate-y-[50%] left-3" />
                            </div>
                        </li>
                    </ul>
                    {(subdivisionloadingstatus.status === 'pending') &&
                        <div className='flex justify-center items-center mb-[40px] mt-[90px]'>
                            <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12 mt-[-45px] spin-animation"></div>
                        </div>
                    }
                    {(subdivisionloadingstatus.status === 'fulfilled') && displayEmptyMsg === "" ?
                        <ul className={`max-h-[440px] overflow-auto scrollbar_gray pr-3`}>
                            <li className='flex justify-between items-center p-2'>
                                <div data-testid="select-all" className="relative checkbox custom-checkBoxBlue1">
                                    <input type="checkbox" id='select_all' data-testid='select_all' checked={(subdivisionData?.data?.every(item=>(selectedSubdivisionName.length>0?(selectedSubdivisionName?.map(obj=>obj?.subdivision_id)):[])?.includes(item?.subdivision_id)))?true:false} onChange={(event)=>handleSelectAll(event,subdivisionData)} />
                                    <label htmlFor='select_all' id='select_all'  className={`text-sm font-normal text-[#031624] w-full cursor-pointer pl-4`}>Select All</label>
                                </div>
                                {selectedSubdivisionName.length > 0 && (
                                    <button className="text-xs font-semibold text-[#008586]" onClick={handleClearAll}>Clear All</button>
                                )}
                            </li>
                            {!subdivisionFetching && subdivisionData !== undefined && subdivisionData !== null && subdivisionData.data.map((item, i) => (
                                <li key={i} className='flex justify-between items-center p-2'>
                                    <div data-testid={`${i}subdivision`} id={`${i}subdivision`} className="relative checkbox custom-checkBoxBlue1 flex items-center">
                                        <input type="checkbox" id={i+item.subdivision_id} onChange={() => handleSelectionSubdivision(item)} checked={selectedSubdivisionName?.length>0&&selectedSubdivisionName?.map(item=>item.subdivision_id)?.includes(item?.subdivision_id)} />
                                        <label  id={i+'subdivision'} title={item.subdivision_name} htmlFor={i+item.subdivision_id} className="text-sm font-normal text-[#031624] w-full cursor-pointer pl-4 more-lines">{item.subdivision_id} {isMonitor ? item.sub_division_name :  item.subdivision_name}</label>
                                    </div>
                                </li>
                            ))}
                        </ul> :
                        <p className="mt-2 text-center">{subdivisionloadingstatus.status === 'pending' ? "" : displayEmptyMsg}</p>}
                </li>
            </ul>
        </div>
    );
}
